<template>
  <div class="video-player">
    <video
      id="video"
      :class="{ 'radius': radius == true }"
      :src="videoPath"
      controls
      :poster="poster"
    >
    </video>
  </div>
</template>

<script>
import 'videojs-contrib-hls'

export default {
  data () {
    return {
      videoInterval: 0
    }
  },
  props: {
    // mp4: String,
    radius: {
      type: Boolean,
      default: true
    },
    poster: String,
    videoPath: String
  },
  mounted () {
    this.videoEvent()
  },
  methods: {
    videoEvent () {
      if (this.videoDom) {
        this.videoDom.onplay = e => {
          this.videoInterval = setInterval(() => {
            // console.log('send');
            this.sendMsg()
          }, 10000)
        }
        this.videoDom.onpause = e => {
          clearInterval(this.videoInterval)
        }
        this.videoDom.onended = e => {
          this.sendMsg()
        }
      }
    },
    control () {
      // this.videoDom.play()
      if (this.videoDom.paused) {
        this.videoDom.play()
      } else {
        this.videoDom.pause()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.videoInterval)
    this.videoInterval = 0
  }
}
</script>

<style lang="scss">
.video-player {
  height: 420px;
  #video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .radius {
    border-radius: 10px;
  }
}
</style>
